$("#buttonNavCatalogRight").on("click", function(e) {
	e.preventDefault();
	$('.nav-wrapper .nav').animate({ scrollLeft: "+=280px" }, "slow");
});

$("#buttonNavCatalogLeft").on("click", function(e) {
	e.preventDefault();
	$('.nav-wrapper .nav').animate({ scrollLeft: "-=280px" }, "slow");
});